export default __webpack_public_path__ + "static/media/01.46a43f09.png";